module.exports = {
    scssVariables: './src/styles/sgpseedcare',
    defaultLanguage: 'en',
    profileColor: {saturation: 70, brighness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}